import PlaceDetailsForm from '../components/add-edit-place/PlaceDetailsForm';
import PlaceAddressesTab from '../components/add-edit-place/PlaceAddressesTab';
import PlaceContactsTab from '../components/add-edit-place/PlaceContactsTab';
import PlaceEmployeesTab from '../components/add-edit-place/PlaceEmployeesTab';
import PlaceSopsTab from '../components/add-edit-place/PlaceSopsTab';
import PlaceVehicleRegistrationsTab from '../components/add-edit-place/PlaceVehicleRegistrationsTab';

import { PlaceMenuItemKey } from './placeMenuItemKeys';

export const PlaceSideBarMenuItem = [
  { key: PlaceMenuItemKey.EDIT_PLACE, label: 'Place', content: PlaceDetailsForm },
  { key: PlaceMenuItemKey.ADDRESS, label: 'Address', content: PlaceAddressesTab },
  { key: PlaceMenuItemKey.CONTACT, label: 'Contact', content: PlaceContactsTab },
  { key: PlaceMenuItemKey.EMPLOYEES, label: 'Employees', content: PlaceEmployeesTab },
  { key: PlaceMenuItemKey.SOPS, label: 'SOPs', content: PlaceSopsTab },
  {
    key: PlaceMenuItemKey.VEHICLES,
    label: 'Vehicle Registrations',
    content: PlaceVehicleRegistrationsTab,
  },
];

export const getSelectedPlaceMenu = (key) =>
  PlaceSideBarMenuItem.find((item) => item.key === key) || null;

export const PlaceSidebarGroups = [{ key: 'place', label: 'Place', items: PlaceSideBarMenuItem }];
